import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Sidebar from "./components/Sidebar";
import ShiftRoomsPage from "./pages/ShiftRoomsPage";
import MultiSiteConsolePage from "./pages/MultiSiteConsolePage";
import HandoffLogPage from "./pages/HandoffLogPage";
import HealthPage from "./pages/HealthPage";
import LoginPage from "./pages/LoginPage";

function Layout({ children }) {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 flex flex-col overflow-hidden">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

function AppRouter() {
  const { user, loading } = useAuth();
  if (loading) return <main className="min-h-screen bg-slate-950 grid place-items-center text-slate-400">Loading…</main>;
  if (!user) return <LoginPage />;
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/"        element={<ShiftRoomsPage />} />
          <Route path="/sites"   element={<MultiSiteConsolePage />} />
          <Route path="/handoff" element={<HandoffLogPage />} />
          <Route path="/health"  element={<HealthPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
